<template>
  <Teleport to="#app">
    <input type="checkbox" :id="id" class="modal-toggle" />
    <label class="modal" :for="id">
      <label class="modal-box" for="">
        <h3 class="font-bold text-lg">{{ title }}</h3>
        <p class="py-4">{{ content }}</p>
        <div class="modal-action">
          <label
            class="btn btn-sm"
            :for="id"
            :class="{ 'pointer-events-none opacity-60': loadingBtn }"
            >{{ __("Cancel") }}</label
          >
          <button
            class="btn btn-error btn-sm text-white"
            @click="$emit('remove')"
            :class="{ loading: loadingBtn }"
          >
            {{ __("Delete") }}
          </button>
        </div>
      </label>
    </label>
  </Teleport>
</template>
<script setup>
const {loadingBtn} = useDashboard();
const props = defineProps({
  id: {
    type: String,
    default: 'delete-modal'
  },
  title: String,
  content: String
});
defineEmits(['remove']);
</script>
